import { render } from "./UiEmptyState.vue?vue&type=template&id=00e0d329"
import script from "./UiEmptyState.vue?vue&type=script&lang=js"
export * from "./UiEmptyState.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__